
import image from "../../media/images/pet11.png";

const MeetExpertsComponent = ({form}) => {

  
  
  return (
    <div>


      
      
      <div className="meet-expert">
        <div className="meet-expert-main">
          <div className="meet-expert-content">
            <div className="meet-expert-content-image">
              <img src={image} title="Pet Grooming Near Me" alt="Dog Grooming " />
            </div>
            <div className="meet-expert-content-main">
              <div className="meet-expert-content-heading">
                Ready to Meet our Grooming Experts?
              </div>
              <div className="meet-expert-content-text">
                Learn more about our experienced groomers and their dedication
                to keeping your pets looking and feeling their best
              </div>
            </div>
            <div onClick={()=>form(true)} className="meet-expert-content-button">Book Groomer</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetExpertsComponent;
